// Modules
import { Link } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';

import { SHORT_HUMAN_DATE_TIME_FORMAT } from 'constants';
import { ShortDate } from 'components/widgets/dates';
import Call from 'services/data/call';
import CompanyNickname from 'components/models/company/company-nickname';
import Email from 'services/data/email';
import EmailMeta from 'components/models/email/emailMeta';
import MonitoringAlert from 'services/data/monitoring-alert';
import Person from 'services/data/person';
import PhoneNumber from 'services/data/phone-number';
import SVG from 'components/widgets/icons/svg';
import TicketLink from 'components/models/ticket/ticket-link';
import Tooltip from 'components/widgets/overlays/tooltip';
import Truncate from 'components/widgets/text/truncate';
import UserInitials from 'components/models/user/user-initials';

import RecordingLink from './recording-link';
import SendToInbox from './send-to-inbox';


export default class TriageRow extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired
  };

  getItemOrigin(item) {
    switch (item.type) {
      case 'call':
        return PhoneNumber.format(item.from);
      case 'email':
        return item.parsedFrom.name || item.parsedFrom.address;
      case 'monitoringalert':
        return item.hostname;
      default:
        break;
    }
  }

  getPayload(item) {
    switch (item.type) {
      case 'call':
        return item.callStatus;
      case 'email':
        return item.subject;
      case 'monitoringalert':
        return item.trigger;
      default:
        break;
    }
  }

  getTypeIcon(item) {
    switch (item.type) {
      case 'call':
        return 'svg/phone.svg';
      case 'email':
        return 'svg/email.svg';
      case 'monitoringalert':
        return 'svg/monitoring-alert.svg';
      default:
        break;
    }
  }

  getStatusTooltip(item) {
    const claimed = !_.isEmpty(item.claimedBy);
    const status = (item.status === 'Active' && claimed) ? 'Claimed' : item.status;

    if (item.type === 'monitoringalert' && item.autoResolved) return `${status} - Auto Resolved`;
    return status;
  }

  getMonitoringAlertFullPayload(item) {
    const isAutoSrvcs = _.startsWith(item.trigger, 'Auto svcs stopped');
    const isDiskSpace = _.startsWith(item.trigger, 'Free space');
    
    if (isAutoSrvcs || isDiskSpace) return `${item.trigger}: ${item.value.replace(/ /g, ', ')}`;
    return item.trigger;
  }

  update(item, updates) {
    switch (item.type) {
      case 'call':
        return Call.update({ id: item.id, ...updates });
      case 'email':
        return Email.update({ id: item.id, ...updates });
      case 'monitoringalert':
        return MonitoringAlert.update({ id: item.id, ...updates });
      default:
        break;
    }
  }

  render() {
    const { item, currentUser } = this.props;
    const isEmail = item.type === 'email';
    const isAlert = item.type === 'monitoringalert';
    const isCall = item.type === 'call';
    const isArchived = item.status === 'Archived';
    const hasTicket = item.ticket && item.ticket.id;
    const payload = this.getPayload(item);
    const fullPayload = isAlert ? this.getMonitoringAlertFullPayload(item) : payload;
    const hasRecording = isCall && item.callStatus === 'Recorded Message';

    const origin = _.isEmpty(item.fromPerson) ? this.getItemOrigin(item) : Person.fullName(item.fromPerson);
    
    return (
      <tr className={classNames({ 'disabled-row': item.status === 'Archived' })}>
        {/* Type/Status */}
        <td className={classNames('type-status-container', _.kebabCase(item.status), { claimed: !_.isEmpty(item.claimedBy) })}>
          <Tooltip className="triage-type-status" title={this.getStatusTooltip(item)}>
            <SVG src={this.getTypeIcon(item)} />
          </Tooltip>
        </td>
        {/* Date */}
        <td>
          <ShortDate title={moment(item.createdAt).format(SHORT_HUMAN_DATE_TIME_FORMAT)} date={item.createdAt} />
        </td>
        {/* Action icons */}
        <td className="icon-cell">
          <div className="flex">
            { isArchived &&
              <Tooltip title="Restore">
                <SVG className="pointer" src="svg/refresh.svg" onClick={() => this.update(item, { status: 'Active' })} />
              </Tooltip>
            }
            { isEmail && <SendToInbox emailId={item.id} currentUser={currentUser} /> }
            { hasRecording && <RecordingLink item={item} /> }
          </div>
        </td>
        <td className="expand-cell"><Truncate tooltip={fullPayload}>{payload}</Truncate></td>
        <td className="expand-cell">
          { isEmail &&
            <Truncate tooltip={<EmailMeta email={item} />} textContent={origin}>
              <Link to={`/people/${item.fromPerson.id}`}>{origin}</Link>
            </Truncate>
          }
          { !isEmail && <Truncate>{origin}</Truncate>}
        </td>
        <td><CompanyNickname company={item.company} /></td>
        { hasTicket &&
          <td className="expand-cell">
            <TicketLink ticket={item.ticket}>
              <Truncate>{item.ticket.description}</Truncate>
            </TicketLink>
          </td>
        }
        { !hasTicket && <td></td> }
        <td>
          <UserInitials user={item.claimedBy} />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-row.js